import { useAppDispatch } from 'state/store';
import {
  setSelectedAssetClassesFactor,
  setSelectedAssetClass,
  setAssetClassType,
} from 'state/store/reducers/marketDataSlice';

export type UseMarketDataActions = {
  setSelectedFactor: (title: string) => void;
  setSelectedAssetClass: (assetClass: string) => void;
  setAssetClassType: (type: string) => void;
};

export const useMarketDataActions = (): UseMarketDataActions => {
  const dispatch = useAppDispatch();

  return {
    setSelectedFactor: (title: string) => {
      dispatch(setSelectedAssetClassesFactor(title));
    },
    setSelectedAssetClass: (assetClass: string) => {
      dispatch(setSelectedAssetClass(assetClass));
    },
    setAssetClassType: (type: string) => {
      dispatch(setAssetClassType(type));
    },
  };
};
